import React, { useState } from 'react';
import { Button, Input, Modal, Tooltip, Typography } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { useCreateJourneyTemplate } from 'services/journeyTemplates';
import { useJourneyDashboardContext } from '../context';

const SaveTemplateButton: React.FC<{ disabled?: boolean; empty?: boolean }> = ({
  disabled,
  empty,
}) => {
  const { id, name, collections } = useJourneyDashboardContext();
  const hasOnDemand = (collections ?? []).some(
    (collection) => collection.type === 'on_demand',
  );
  const { mutateAsync: save, isPending } = useCreateJourneyTemplate();
  const [open, setOpen] = useState(false);
  const [templateName, setTemplateName] = useState('');

  const confirm = async () => {
    if (!id || !templateName.trim()) return;
    try {
      await save({ journeyId: id, name: templateName.trim() });
      setOpen(false);
    } catch {}
  };

  return (
    <>
      <Tooltip
        title={
          empty
            ? 'Agregá al menos una colecta para guardarla como plantilla'
            : undefined
        }
      >
        <Button
          size="small"
          icon={<SaveOutlined />}
          disabled={disabled || !id || empty}
          onClick={() => {
            setTemplateName(name ?? '');
            setOpen(true);
          }}
        >
          Guardar como plantilla
        </Button>
      </Tooltip>
      <Modal
        open={open}
        title="Guardar como plantilla"
        okText="Guardar"
        cancelText="Cancelar"
        confirmLoading={isPending}
        okButtonProps={{ disabled: !templateName.trim() }}
        onOk={confirm}
        onCancel={() => setOpen(false)}
        destroyOnClose
      >
        <Typography.Paragraph>
          Se guardan los puntos de colecta de esta ruta en su orden, con la hora
          y la duración de cada uno, y el driver que tiene. Después la podés
          volver a armar desde Rutas → Plantillas.
        </Typography.Paragraph>
        {hasOnDemand && (
          <Typography.Paragraph type="warning">
            Las colectas a demanda no se guardan en la plantilla.
          </Typography.Paragraph>
        )}
        <Input
          autoFocus
          maxLength={60}
          value={templateName}
          placeholder="Nombre de la plantilla"
          onChange={(event) => setTemplateName(event.target.value)}
          onPressEnter={confirm}
        />
      </Modal>
    </>
  );
};

export default SaveTemplateButton;
